import { Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BusinessService {

  private businessId: string | null = null;

  private linksRegistro: any | null = {
    '1': 'https://portal-beneficiario-hml.hapvidalabs.net/cadastro', //hapvida
    '8': 'https://portal-beneficiario.ccgsaude.com.br/cadastro', //ccg
    '9': 'https://portal-beneficiario.clinipam.com.br/cadastro', //clinipan
    '10': 'https://portal-beneficiario.gndiminas.com.br/cadastro', //ndi-minas
  };

  constructor() {}

  setBusinessId(businessId: string) {
    localStorage.setItem('cod_empresa', businessId);
    this.businessId = businessId;
  }

  getBusinessId(): string | null {
    let businessId = localStorage.getItem('cod_empresa');
    if (businessId) {
      this.businessId = businessId;
    }
    return this.businessId;
  }

  getBusinessUrl(): string | null {
    if (this.businessId == '1') {
      return 'https://www.hapvida.com.br';
    } else if (this.businessId == '8') {
      return 'https://www.ccgsaude.com.br';
    } else if (this.businessId == '9') {
      return 'https://gndisul.com.br';
    } else if (this.businessId == '10') {
      return 'https://www.gndiminas.com.br';
    }

    
    return null;
  }

  getLinkRegistrar(): string | null {
    return (this.linksRegistro[this.businessId]) ? this.linksRegistro[this.businessId] : '' ;
  }

  temLinkRegistrar(): boolean | null {
    return ( this.linksRegistro[this.businessId] !== undefined && this.linksRegistro[this.businessId] !== null)
  }

}
